<template>
    <div class="row tab-panel" v-show="currentTab == tabName">
        <slot></slot>
    </div>
</template>
<script>
export default {
    props: {
        tabName: String,
        currentTab: String
    }
}
</script>
<style scoped>
</style>